/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TypescriptAnalysisImport } from './routes/typescript-analysis'
import { Route as IndexImport } from './routes/index'
import { Route as CompileRunCompileIdImport } from './routes/compile-run.$compileId'

// Create/Update Routes

const TypescriptAnalysisRoute = TypescriptAnalysisImport.update({
  id: '/typescript-analysis',
  path: '/typescript-analysis',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const CompileRunCompileIdRoute = CompileRunCompileIdImport.update({
  id: '/compile-run/$compileId',
  path: '/compile-run/$compileId',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/typescript-analysis': {
      id: '/typescript-analysis'
      path: '/typescript-analysis'
      fullPath: '/typescript-analysis'
      preLoaderRoute: typeof TypescriptAnalysisImport
      parentRoute: typeof rootRoute
    }
    '/compile-run/$compileId': {
      id: '/compile-run/$compileId'
      path: '/compile-run/$compileId'
      fullPath: '/compile-run/$compileId'
      preLoaderRoute: typeof CompileRunCompileIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/typescript-analysis': typeof TypescriptAnalysisRoute
  '/compile-run/$compileId': typeof CompileRunCompileIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/typescript-analysis': typeof TypescriptAnalysisRoute
  '/compile-run/$compileId': typeof CompileRunCompileIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/typescript-analysis': typeof TypescriptAnalysisRoute
  '/compile-run/$compileId': typeof CompileRunCompileIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/typescript-analysis' | '/compile-run/$compileId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/typescript-analysis' | '/compile-run/$compileId'
  id: '__root__' | '/' | '/typescript-analysis' | '/compile-run/$compileId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TypescriptAnalysisRoute: typeof TypescriptAnalysisRoute
  CompileRunCompileIdRoute: typeof CompileRunCompileIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TypescriptAnalysisRoute: TypescriptAnalysisRoute,
  CompileRunCompileIdRoute: CompileRunCompileIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/typescript-analysis",
        "/compile-run/$compileId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/typescript-analysis": {
      "filePath": "typescript-analysis.tsx"
    },
    "/compile-run/$compileId": {
      "filePath": "compile-run.$compileId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
